export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-shield-star-line',
      title: 'Confianza',
      description: 'Para presentarse y expresarse con valentía',
      color: 'from-[#D2691E] to-[#B8571A]'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Disciplina',
      description: 'Que se traslada a la escuela y la vida',
      color: 'from-[#E8A317] to-[#D2691E]'
    },
    {
      icon: 'ri-team-line',
      title: 'Trabajo en Equipo',
      description: 'Y respeto por los demás',
      color: 'from-[#8D6E63] to-[#6D4C41]'
    },
    {
      icon: 'ri-music-2-line',
      title: 'Habilidad Musical',
      description: 'Y expresión artística auténtica',
      color: 'from-[#D2691E] to-[#B8571A]'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Sentido de Pertenencia',
      description: 'A una comunidad y tradición cultural',
      color: 'from-[#E8A317] to-[#D2691E]'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Orgullo en el Logro',
      description: 'Que construye autoestima duradera',
      color: 'from-[#8D6E63] to-[#6D4C41]'
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            ¿Qué Gana Tu Hijo?
          </h2>
          <p className="text-xl text-gray-600">
            Crecimiento que puedes ver... y sentir
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {benefits.map((benefit, index) => (
            <div key={index} className="group">
              <div className="bg-gradient-to-br from-[#FFF8E1] to-[#FFECB3] rounded-3xl p-8 mb-6 h-64 flex items-center justify-center transition-transform group-hover:scale-105">
                <div className={`w-32 h-32 bg-gradient-to-br ${benefit.color} rounded-3xl flex items-center justify-center shadow-xl`}>
                  <i className={`${benefit.icon} text-6xl text-white`}></i>
                </div>
              </div>
              
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 mb-6">{benefit.description}</p>
                
                {index === 0 ? (
                  <button 
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) {
                        const offset = 80;
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - offset;
                        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                      }
                    }}
                    className="bg-[#D2691E] text-white px-6 py-3 rounded-full hover:bg-[#B8571A] transition-all shadow-md whitespace-nowrap"
                  >
                    Conoce Más
                  </button>
                ) : (
                  <button 
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) {
                        const offset = 80;
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - offset;
                        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                      }
                    }}
                    className="border-2 border-[#D2691E] text-[#D2691E] px-6 py-3 rounded-full hover:bg-[#D2691E] hover:text-white transition-all whitespace-nowrap"
                  >
                    Conoce Más
                  </button>
                )}
                
                <p className="text-sm text-gray-400 mt-3">Edades 5-17 años</p>
              </div>
            </div>
          ))}
        </div>

        <div 
          className="relative rounded-3xl overflow-hidden shadow-2xl min-h-[600px] flex items-center justify-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/86c25b1fed1a07b24a2e3b37a0f49c42.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-[#D2691E]/25"></div>
          
          <div className="relative z-10 text-center text-white px-6 max-w-4xl">
            <h2 className="text-5xl md:text-6xl font-bold mb-8 tracking-wide uppercase">
              IMAGINA ESTE MOMENTO
            </h2>
            <p className="text-2xl md:text-3xl font-light mb-12 leading-relaxed">
              Tu hijo en el escenario. Enfocado. Confiado. Orgulloso.
            </p>
            
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center bg-black text-white rounded-full shadow-2xl hover:scale-105 transition-transform overflow-hidden whitespace-nowrap"
            >
              <div className="w-16 h-16 bg-[#E8A317] rounded-full flex items-center justify-center">
                <i className="ri-calendar-check-line text-2xl text-white"></i>
              </div>
              <span className="px-8 font-bold text-lg uppercase tracking-wider">
                INSCRIBE A TU HIJO HOY
              </span>
              <i className="ri-arrow-right-up-line text-2xl mr-6"></i>
            </button>
          </div>
        </div>

        <div className="mt-20 bg-gradient-to-br from-[#FFF8E1] to-[#FFECB3] rounded-3xl p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 bg-[#D2691E] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-gift-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#3E2723] mb-6">
              Dale a Tu Hijo un Regalo que Dura
            </h3>
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              Los deportes terminan. Los juguetes se rompen.
              <br />
              Pero la confianza, la disciplina y el amor por la música permanecen de por vida.
            </p>
            <p className="text-sm text-gray-600 italic">
              Los cupos son limitados para asegurar instrucción de calidad
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
